import { render, staticRenderFns } from "./OrderPriceChangePopup.vue?vue&type=template&id=b225ce62&"
import script from "./OrderPriceChangePopup.vue?vue&type=script&lang=js&"
export * from "./OrderPriceChangePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports